// extracted by mini-css-extract-plugin
export var columnList = "_gl-0";